module.exports = __webpack_public_path__ + "static/media/GA.45fdf0e3.png";